<div class="container">
  <div class="left-section">
    <!-- <button (click)="addNewRow()" [disabled]="isAddButtonDisabled">Add</button> -->
    <div class="button-row">
      <button class="btn btn-outline-success" (click)="addNewRow()" [disabled]="isAddButtonDisabled()">
        <i class="fa fa-plus"></i> Add
      </button>
    </div>

    <table>
      <thead>
        <tr>
          <th>File Name</th>
          <th>Color</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        @if (isNewRowVisible()) {
          <tr>
            <td> <input type="file" id="selectedFile" #fileInput style="display: none;" (change)="addFile($event)" />
              <input type="button" class="btn btn-outline-primary"  value="Browse..." onclick="document.getElementById('selectedFile').click();" />
            </td>
            <td>
              <label for="epsgInput">EPSG:  </label>
              <input type="number" id="epsgInput" [(ngModel)]="epsg" (change)="onEpsgChange()"/>
            </td>
            <td><input type="color" [(ngModel)]="newFileColor" (change)="OnImportColorChanged()"/></td>
            <td>
              <button class="btn btn-outline-success" [disabled]="!saveable()" (click)="saveNewFile()">
                <i class="fa fa-save"></i> Save
              </button>
            </td>
          </tr>
        }
        @for (file of files(); track file; let i = $index) {
          <tr>
            <td>{{ file.name }}</td>
            <td>
            <input type="color" [(ngModel)]="file.color" (change)="OnLineColorChange(file, file.color)"/>              </td>
            <td>
              <i class="fa" [ngClass]="file.isVisible ? 'fa-eye' : 'fa-eye-slash'"></i>
            </td>
            <td>
              <button class="btn btn-outline-danger" (click)="deleteFile(i, file)">
                <i class="fa fa-trash"></i> Delete
              </button>
            </td>
          </tr>
        }
      </tbody>
    </table>
    <!-- <div class="file-input-section">
    <input type="file" #fileInput  (change)="addFile($event)" />
    <label for="epsgInput">EPSG</label>
    <input type="number" id="epsgInput" [(ngModel)]="epsg" (change)="onEpsgChange()"/>
  </div> -->

</div>

<div class="right-section" id="map">
</div>


</div>